<template>
  <div class="wizard-body small-9 columns">
    <page-header
      :header-title="$t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.DESC')"
    />
    <form class="row" @submit.prevent="createChannel()">
      <div class="medium-8 columns">
        <label :class="{ error: $v.channelName.$error }">
          {{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.CHANNEL_NAME.LABEL') }}
          <input
            v-model.trim="channelName"
            type="text"
            :placeholder="$t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.CHANNEL_NAME.PLACEHOLDER')"
            @blur="$v.channelName.$touch"
          />
          <span v-if="$v.channelName.$error" class="message">
            {{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.CHANNEL_NAME.ERROR') }}
          </span>
        </label>
      </div>

      <div class="medium-8 columns">
        <label :class="{ error: $v.baseUrl.$error }">
          {{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.BASE_URL.LABEL') }}
          <input
            v-model.trim="baseUrl"
            type="text"
            :placeholder="$t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.BASE_URL.PLACEHOLDER')"
            @blur="onCredentialBlur"
          />
          <span v-if="$v.baseUrl.$error" class="message">
            {{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.BASE_URL.ERROR') }}
          </span>
        </label>
      </div>

      <div class="medium-8 columns">
        <label :class="{ error: $v.apiKey.$error }">
          {{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.API_KEY.LABEL') }}
          <input
            v-model.trim="apiKey"
            type="text"
            :placeholder="$t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.API_KEY.PLACEHOLDER')"
            @blur="onCredentialBlur"
          />
          <span v-if="$v.apiKey.$error" class="message">
            {{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.API_KEY.ERROR') }}
          </span>
        </label>
      </div>

      <div class="medium-8 columns">
        <label :class="{ error: $v.channelType.$error }">
          {{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.CHANNEL_TYPE.LABEL') }}
          <select v-model="channelType" @change="$v.channelType.$touch">
            <option value="">Selecione o tipo</option>
            <option value="whatsapp">{{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.CHANNEL_TYPE.OPTIONS.WHATSAPP') }}</option>
            <option value="live_chat">{{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.CHANNEL_TYPE.OPTIONS.LIVE_CHAT') }}</option>
          </select>
          <span v-if="$v.channelType.$error" class="message">
            {{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.CHANNEL_TYPE.ERROR') }}
          </span>
        </label>
      </div>

      <div class="columns medium-12">
        <button
          class="header-section back-button"
          @click.prevent="showCustomFilters = !showCustomFilters"
        >
          {{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.TITLE') }}
          <div class="chevron-icon__wrap">
            <fluent-icon v-if="showCustomFilters" icon="chevron-up" />
            <fluent-icon v-else icon="chevron-down" />
          </div>
        </button>
      </div>

      <div v-if="showCustomFilters" class="columns medium-12">
        <div v-if="channelType === 'whatsapp'" class="medium-8 columns">
          <label>
            {{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.PHONE_NUMBER.LABEL') }}
            <input
              v-model.trim="phoneNumber"
              type="text"
              :placeholder="$t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.PHONE_NUMBER.PLACEHOLDER')"
            />
          </label>
          <p class="help-text">{{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.PHONE_NUMBER.HELP') }}</p>
        </div>

        <div v-if="channelType === 'live_chat'" class="medium-8 columns">
          <label>
            {{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.WIDGET_ID.LABEL') }}
            <input
              v-model.trim="widgetId"
              type="text"
              :placeholder="$t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.WIDGET_ID.PLACEHOLDER')"
            />
          </label>
          <p class="help-text">{{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.WIDGET_ID.HELP') }}</p>
        </div>

        <div class="medium-8 columns">
          <label>
            {{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.STATUS.LABEL') }}
            <select v-model="statusFilter">
              <option value="">{{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.STATUS.ALL') }}</option>
              <option value="SOLVED">{{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.STATUS.OPTIONS.SOLVED') }}</option>
              <option value="CLOSED">{{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.STATUS.OPTIONS.CLOSED') }}</option>
              <option value="OPEN">{{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.STATUS.OPTIONS.OPEN') }}</option>
              <option value="WAITING">{{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.STATUS.OPTIONS.WAITING') }}</option>
            </select>
          </label>
          <p class="help-text">{{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.STATUS.HELP') }}</p>
        </div>

        <div class="medium-8 columns">
          <label>
            {{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.PRIORITY.LABEL') }}
            <select v-model="priority">
              <option value="">{{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.PRIORITY.ALL') }}</option>
              <option value="URGENT">{{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.PRIORITY.OPTIONS.URGENT') }}</option>
              <option value="HIGH">{{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.PRIORITY.OPTIONS.HIGH') }}</option>
              <option value="NORMAL">{{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.PRIORITY.OPTIONS.NORMAL') }}</option>
              <option value="LOW">{{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.PRIORITY.OPTIONS.LOW') }}</option>
            </select>
          </label>
          <p class="help-text">{{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.PRIORITY.HELP') }}</p>
        </div>

        <div class="medium-8 columns">
          <label>
            {{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.AGENT_ID.LABEL') }}
            <multiselect
              v-model="selectedAgents"
              select-label=""
              selected-label="Selecionado"
              deselect-label=""
              :placeholder="$t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.AGENT_ID.PLACEHOLDER')"
              label="displayName"
              track-by="id"
              :loading="loadingAgents"
              :max-height="160"
              :allow-empty="true"
              :multiple="true"
              :options="agentOptions"
              :disabled="!showAgents"
              :searchable="true"
            >
              <span slot="noOptions">{{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.AGENT_ID.NO_OPTIONS') }}</span>
            </multiselect>
          </label>
          <p class="help-text">{{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.AGENT_ID.HELP') }}</p>
        </div>

        <div class="medium-8 columns">
          <label>
            {{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.QUEUE_IDS.LABEL') }}
            <multiselect
              v-model="selectedQueues"
              selectedLabel="Selecionado"
              :placeholder="$t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.QUEUE_IDS.PLACEHOLDER')"
              label="name"
              track-by="id"
              deselect-label=""
              :loading="loadingQueues"
              :max-height="160"
              :allow-empty="true"
              :option-height="104"
              :multiple="true"
              :options="queueOptions"
              :disabled="!showQueues"
              :searchable="true"
            >
              <span slot="noOptions">{{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.QUEUE_IDS.NO_OPTIONS') }}</span>
            </multiselect>
          </label>
          <p class="help-text">{{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.QUEUE_IDS.HELP') }}</p>
        </div>

        <div class="medium-8 columns">
          <label>
            {{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.TAG_NAMES.LABEL') }}
            <multiselect
              v-model="selectedTags"
              selectedLabel="Selecionado"
              :placeholder="$t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.TAG_NAMES.PLACEHOLDER')"
              label="name"
              track-by="name"
              deselect-label=""
              :loading="loadingTags"
              :max-height="160"
              :allow-empty="true"
              :option-height="104"
              :multiple="true"
              :options="tagOptions"
              :disabled="!showTags"
              :searchable="true"
            >
              <span slot="noOptions">{{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.TAG_NAMES.NO_OPTIONS') }}</span>
            </multiselect>
          </label>
          <p class="help-text">{{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.TAG_NAMES.HELP') }}</p>
        </div>

        <div class="medium-8 columns">
          <label :class="{ error: $v.minMessages.$error }">
            {{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.MIN_MESSAGES.LABEL') }}
            <input v-model.trim="minMessages" type="text" @blur="$v.minMessages.$touch" />
            <span v-if="$v.minMessages.$error" class="message">{{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.MIN_MESSAGES.ERROR') }}</span>
          </label>
          <p class="help-text">{{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.MIN_MESSAGES.HELP') }}</p>
        </div>

        <div class="medium-8 columns">
          <label :class="{ error: $v.customerMinMessages.$error }">
            {{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.CUSTOMER_MIN_MESSAGES.LABEL') }}
            <input v-model.trim="customerMinMessages" type="text" @blur="$v.customerMinMessages.$touch" />
            <span v-if="$v.customerMinMessages.$error" class="message">{{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.CUSTOMER_MIN_MESSAGES.ERROR') }}</span>
          </label>
          <p class="help-text">{{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.CUSTOMER_MIN_MESSAGES.HELP') }}</p>
        </div>

        <div class="medium-8 columns">
          <label :class="{ error: $v.operatorMinMessages.$error }">
            {{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.OPERATOR_MIN_MESSAGES.LABEL') }}
            <input v-model.trim="operatorMinMessages" type="text" @blur="$v.operatorMinMessages.$touch" />
            <span v-if="$v.operatorMinMessages.$error" class="message">{{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.OPERATOR_MIN_MESSAGES.ERROR') }}</span>
          </label>
          <p class="help-text">{{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.OPERATOR_MIN_MESSAGES.HELP') }}</p>
        </div>

        <div class="medium-8 columns">
          <label class="bot-switch">
            {{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.COUNT_BOT_MESSAGES.LABEL') }}
            <woot-switch v-model="countBotMessages" />
            <p class="help-text">{{ $t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.FILTERS.COUNT_BOT_MESSAGES.HELP') }}</p>
          </label>
        </div>

      </div>

      <div class="divider">&nbsp;</div>

      <div class="medium-12 columns">
        <woot-submit-button
          :loading="uiFlags.isCreating"
          :button-text="$t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.SUBMIT_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>

<script>
import { required, numeric } from 'vuelidate/lib/validators';
import PageHeader from '../../SettingsSubPageHeader';
import alertMixin from 'shared/mixins/alertMixin';
import getUuid from 'widget/helpers/uuid';
import router from '../../../../index';
import { mapGetters } from 'vuex';

export default {
  name: 'InfobipChannel',
  components: { PageHeader },
  mixins: [alertMixin],
  data() {
    return {
      channelName: '',
      baseUrl: '',
      apiKey: '',
      channelType: '',
      statusFilter: 'SOLVED',
      priority: '',
      selectedAgents: [],
      selectedQueues: [],
      selectedTags: [],
      phoneNumber: '',
      widgetId: '',
      minMessages: '',
      customerMinMessages: '',
      operatorMinMessages: '',
      countBotMessages: false,
      showCustomFilters: false,
      showAgents: false,
      showQueues: false,
      showTags: false,
      agentOptions: [],
      queueOptions: [],
      tagOptions: [],
      loadingAgents: false,
      loadingQueues: false,
      loadingTags: false,
    };
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags' }),
    canLoadFilters() {
      return this.baseUrl.length > 0 && this.apiKey.length > 0;
    },
  },
  watch: {
    showCustomFilters(newVal) {
      if (newVal && this.canLoadFilters) {
        this.loadAgents();
        this.loadQueues();
        this.loadTags();
      }
    },
  },
  validations: {
    channelName: { required },
    baseUrl: { required },
    apiKey: { required },
    channelType: { required },
    minMessages: { numeric },
    customerMinMessages: { numeric },
    operatorMinMessages: { numeric },
  },
  methods: {
    onCredentialBlur() {
      if (this.canLoadFilters) {
        this.loadAgents();
        this.loadQueues();
        this.loadTags();
      }
    },
    async loadAgents() {
      this.showAgents = false;
      try {
        this.loadingAgents = true;
        const response = await this.$store.dispatch('inboxes/getInfobipAgents', {
          baseUrl: this.baseUrl,
          apiKey: this.apiKey,
        });
        this.agentOptions = response?.data?.agents || [];
        this.showAgents = true;
      } catch (_) {
        this.agentOptions = [];
      } finally {
        this.loadingAgents = false;
      }
    },
    async loadQueues() {
      this.showQueues = false;
      try {
        this.loadingQueues = true;
        const response = await this.$store.dispatch('inboxes/getInfobipQueues', {
          baseUrl: this.baseUrl,
          apiKey: this.apiKey,
        });
        this.queueOptions = response?.data?.queues || [];
        this.showQueues = true;
      } catch (_) {
        this.queueOptions = [];
      } finally {
        this.loadingQueues = false;
      }
    },
    async loadTags() {
      this.showTags = false;
      try {
        this.loadingTags = true;
        const response = await this.$store.dispatch('inboxes/getInfobipTags', {
          baseUrl: this.baseUrl,
          apiKey: this.apiKey,
        });
        this.tagOptions = response?.data?.tags || [];
        this.showTags = true;
      } catch (_) {
        this.tagOptions = [];
      } finally {
        this.loadingTags = false;
      }
    },
    async createChannel() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      const customConfig = {};
      if (this.statusFilter) customConfig.status = this.statusFilter;
      if (this.priority) customConfig.priority = this.priority;
      if (this.selectedAgents.length) customConfig.agentIds = this.selectedAgents.map(a => a.id);
      if (this.selectedQueues.length) customConfig.queueIds = this.selectedQueues.map(q => q.id);
      if (this.selectedTags.length) customConfig.tagNames = this.selectedTags.map(t => t.name);
      if (this.channelType === 'whatsapp' && this.phoneNumber) customConfig.phone_number = this.phoneNumber;
      if (this.channelType === 'live_chat' && this.widgetId) customConfig.widget_id = this.widgetId;
      if (this.minMessages) customConfig.min_messages = parseInt(this.minMessages);
      if (this.customerMinMessages) customConfig.customer_min_messages = parseInt(this.customerMinMessages);
      if (this.operatorMinMessages) customConfig.operator_min_messages = parseInt(this.operatorMinMessages);
      customConfig.count_bot_messages = this.countBotMessages;

      try {
        const infobipChannel = await this.$store.dispatch('inboxes/createChannel', {
          name: this.channelName,
          channel: {
            type: 'infobip',
            identifier: getUuid(),
            api_key: this.apiKey,
            base_url: this.baseUrl,
            channel_type: this.channelType,
            custom_config: customConfig,
          },
        });

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: { page: 'new', inbox_id: infobipChannel.id },
        });
      } catch (error) {
        this.showAlert(this.$t('INBOX_MGMT.ADD.INFOBIP_CHANNEL.API.ERROR_MESSAGE'));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wizard-body {
  .divider {
    background: #b8b9bb;
    height: 1px;
    margin: 1.5rem 0;
    flex: 0 0 100%;
  }
}

.bot-switch {
  .help-text {
    margin-top: 2px;
  }
}
</style>
